import * as actionTypes from './actionTypes'

export const setHeaderTitle = title => {
    return {
        type : actionTypes.SET_HEADER_TITLE,
        payLoad : { title }
    }
};

export const changeLanguage = lang => {
    return {
        type : actionTypes.CHANGE_LANGUAGE,
        payLoad : { lang }
    }
};


/** WEBPACK FOOTER **
 ** ./src/store/actions/headerAction.js
 **/